/* eslint-disable */
function errorMessage(error, $parentElement, $selectorElement) {
  const $optionWrap = $parentElement.querySelector('.js-quick-add-option-wrap');
  if ($optionWrap) {
    $optionWrap.remove();
  }

  const { status, message, description } = error.responseJSON;
  const lowerCaseStatusCode = status ? (`${status}`).toLowerCase() : '';
  const $errorElement = $parentElement.querySelector('.js-quick-add-error');
  let errorHtml;

  if (lowerCaseStatusCode.includes('requires') && lowerCaseStatusCode.includes('membership')) {
    errorHtml = `
      <div class="quick-add-error__icon">
        <i class="icon icon--error-exclamation-small"></i>
      </div>
      <div class="quick-add-error__content">
        <p class="quick-add-error__title">
          ${message}
        </p>
      </div>
    `;
  } else {
    errorHtml = `
      <div class="quick-add-error__icon">
        <i class="icon icon--error-exclamation-small"></i>
      </div>
      <div class="quick-add-error__content">
        <h5 class="quick-add-error__title">
          ${message}
        </h5>
        ${description && description !== message ? `<p class="quick-add-error__description">${description}</p>` : ''}
      </div>
    `;
  }
  $errorElement.innerHTML = errorHtml;
  $selectorElement.classList.add('is-visible');
  $selectorElement.dataset.currentStep = 'error';
}

function errorChecking(selector) {
  const { customerPurchaseMetafield, isExclusiveMember, quickAddMessages, mattelUrl, mattelShopUrl, mattelClientId, bagItems } = SDG.Data;
  const productTags = selector?.dataset?.productTags;
  const productId = selector?.dataset?.productId;
  const tagArray = productTags ? productTags.split(',') : [];
  const limitTag = tagArray.find((tag) => tag.includes('limit_'));
  const brandTag = tagArray.find((tag) => tag.includes('brand_'));
  const isMembershipProduct = tagArray.find((tag) => tag.includes('Category: Digital Memberships'));
  const hasMembershipInCart = bagItems
  .find((product) => product.title.includes((brandTag || '').replace('brand_', '')));
  const productBrandMatchesActiveMembership = isExclusiveMember && brandTag ? isExclusiveMember.includes(brandTag.replace('brand_', '')) : false;
  const productCountInBag = bagItems
  .filter(
    (product) =>
      product.product_id?.toString() === productId ||
      product.id?.toString() === productId
  )
  .reduce((acc, curr) => acc + (curr.quantity || 0), 0);
  let limitReached = limitTag ? Number(limitTag.replace('limit_', '')) <= productCountInBag : false;

  let errorObj = false;
  const productSku = selector?.dataset?.productSku;

  // Check if product is coming soon and prevent adding to cart
  const comingSoonDate = selector?.dataset?.comingsoonDate;
  const hasComingSoonBadge = selector?.dataset?.hasComingsoonBadge === 'true';
  
  if (comingSoonDate && hasComingSoonBadge) {
    // Parse the coming soon date
    const comingSoonExpiry = `${comingSoonDate.replace(' AEST', ' +1000')}`;
    const comingSoonExpiryDate = new Date(comingSoonExpiry);
    const now = new Date();

    if (comingSoonExpiryDate > now) {
      errorObj = {
        responseJSON: {
          status: '500 coming soon',
          message: 'This product is not available for purchase yet. Please check back later.',
        },
      };

      errorMessage(errorObj, selector.closest('.product-quick-add'), selector);
      return errorObj;
    }
  }

  if (customerPurchaseMetafield && limitTag && productSku) {
    const purchasedTag = customerPurchaseMetafield
      .find((metaItem) => metaItem.sku === productSku);
    const limitInteger = limitTag ? Number(limitTag.replace('limit_', '')) : null;
    const purchasedInteger = purchasedTag ? Number(purchasedTag.quantity) : null;

    if (limitInteger && purchasedInteger && productCountInBag) {
      limitReached = (purchasedInteger + productCountInBag) >= limitInteger;
    } else if (limitInteger && purchasedInteger) {
      limitReached = purchasedInteger >= limitInteger;
    }
  }

  if (limitReached) {
    errorObj = {
      responseJSON: {
        status: '500 quantity limit',
        message: quickAddMessages.limit_reached,
      },
    };

    errorMessage(errorObj, selector.closest('.product-quick-add'), selector);
    return errorObj;
  }

  if (
    brandTag
    && !isMembershipProduct
    && !hasMembershipInCart
  ) {
    if (!productBrandMatchesActiveMembership && SDG.Data.customerEmail) {
      errorObj = {
        responseJSON: {
          status: '500 requires membership',
          message: quickAddMessages.active_membership_required,
        },
      };
    } else if (!productBrandMatchesActiveMembership) {
      const params = new URLSearchParams(window.location.search);
      const emailFromParam = encodeURIComponent(params.get('cm'));
      const returnURL = window.location.pathname;
      const action = emailFromParam !== 'null' ? 'register' : 'login';
      let loginURL = `${mattelUrl}?shop_url=https%3A%2F%2F${mattelShopUrl}&return_to=${returnURL}&client_id=${mattelClientId}&action=${action}`;
      if (emailFromParam !== 'null') loginURL += `&login_hint=${emailFromParam}`;

      errorObj = {
        responseJSON: {
          status: '500 requires membership',
          // eslint-disable-next-line
          message: (quickAddMessages.membership_required || '').replace('/account/login\"', `${loginURL}" class="js-quick-add-login"`),
        },
      };
    }

    errorMessage(errorObj, selector.closest('.product-quick-add'), selector);
    return errorObj;
  }
}

function bindQuickAddEventsRecommendations(container = document, isCartPage = false) {
  function quickAddToCart() {
    const variantId = this.dataset.variantId;

    // if no variantId, there's a next step
    if (!variantId) {
      const jsAddSelector = this.closest('.js-quick-add-selector');
      jsAddSelector.dataset.selectedOption = this.dataset.option;

      // continue to next step
      const currentStep = parseInt(jsAddSelector.dataset.currentStep, 10) || 1;
      jsAddSelector.dataset.currentStep = currentStep + 1;

      if(currentStep === 1) {
        const selectedOptionsMatched = jsAddSelector.querySelectorAll(`.product-quick-add__variant-option[data-option-1=${this.dataset.option}]`);
        if(selectedOptionsMatched.length) {
          selectedOptionsMatched.forEach(button => {
            button.classList.remove('hidden');
          });
        }
      }
      return;
    }

    const parent = this.closest('.product-quick-add');
    const selector = parent.querySelector('.js-quick-add-selector');
    const errorContainer = selector.querySelector('.js-quick-add-error');
    const productTags = selector.dataset.productTags?.split(',') || [];
    const productSku = selector.dataset.productSku;
    const encodedInventory = selector.dataset.variantInventory;
    const encodedVariants = selector.dataset.encodedVariants;
    const variantInventory = encodedInventory ? JSON.parse(decodeURIComponent(encodedInventory)) : [];
    const variantData = encodedVariants ? JSON.parse(decodeURIComponent(encodedVariants)) : [];
    const matchedInventory = variantInventory?.[0]?.variant_inventory?.find(i => i.variant_fulfillmentItem === productSku);

    const properties = {
      _referrer: 'Standard',
      _productType: 'ItemBean',
    };

    if (matchedInventory?.variant_backorderdate) {
      properties._variant_backorderdate = matchedInventory.variant_backorderdate;
    }
    if (matchedInventory?.variant_inventorystatus) {
      properties._variant_inventorystatus = matchedInventory.variant_inventorystatus;
    }

    const bundleTag = productTags.find(tag => tag.toLowerCase() === 'bundled');
    if (bundleTag && variantData?.length) {
      properties._item_bundle_id = variantData[0].sku;
    }

    // Additional coming soon validation for quick add
    const comingSoonDate = selector?.dataset?.comingsoonDate;
    const hasComingSoonBadge = selector?.dataset?.hasComingsoonBadge === 'true';
    
    if (comingSoonDate && hasComingSoonBadge) {
      // Parse the coming soon date
      let targetDate;
      if (comingSoonDate.includes('AEST')) {
        // Handle AEST timezone conversion
        const cleanDate = comingSoonDate.replace(/\s*AEST\s*$/g, '');
        const dateParts = cleanDate.match(/(\d{2})\/(\d{2})\/(\d{4})\s+(\d{1,2}):(\d{2}):(\d{2})\s*(AM|PM)/i);
        if (dateParts) {
          const month = dateParts[1];
          const day = dateParts[2];
          const year = dateParts[3];
          let hour = parseInt(dateParts[4]);
          const minute = dateParts[5];
          const second = dateParts[6];
          const ampm = dateParts[7].toUpperCase();
          
          // Convert to 24-hour format
          if (ampm === 'PM' && hour !== 12) hour += 12;
          if (ampm === 'AM' && hour === 12) hour = 0;
          
          // Format as ISO string with AEST timezone offset (+10:00)
          const isoString = year + '-' + month + '-' + day + 'T' + 
                           (hour < 10 ? '0' : '') + hour + ':' + minute + ':' + second + '+10:00';
          
          targetDate = new Date(isoString).getTime();
        } else {
          targetDate = new Date(cleanDate).getTime();
        }
      } else if (comingSoonDate.includes('UTC')) {
        // Handle UTC dates
        const cleanDate = comingSoonDate.replace(/\s*UTC\s*$/g, '');
        targetDate = new Date(cleanDate).getTime();
      } else {
        // Default handling for dates without timezone
        targetDate = new Date(comingSoonDate).getTime();
      }

      const now = new Date().getTime();
      
      if (targetDate && now < targetDate) {
        if (errorContainer) {
          errorContainer.innerHTML = `
            <div class="quick-add-error__icon">
              <i class="icon icon--error-exclamation-small"></i>
            </div>
            <div class="quick-add-error__content">
              <p class="quick-add-error__title">
                This product is not available for purchase yet. Please check back later.
              </p>
            </div>
          `;
        }
        return;
      }
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: parseInt(variantId),
            quantity: 1,
            properties
          }
        ]
      })
    })
      .then(response => response.json())
      .then(cart => {
        if (isCartPage) {
          window.location.reload();
          return;
        }

        const event = new CustomEvent('theme:cart:updated', {
          detail: {
            cart,
            forceOpening: true,
            fromButton: this.closest('.product-quick-add'),
          }
        });
        const cartCount = document.querySelector('.header__cart-count');
        if (cartCount) {
          cartCount.innerText = Number(cartCount.innerText) + 1;
        }
        document.dispatchEvent(event);

        fetch('/cart.json').then(response => response.json()).then(cart => {
          SDG.Data.bagItems = cart.items;
        }).catch(error => {
          console.error('Error updating bagItems:', error);
        });
      })
      .catch(error => {
        console.error('Quick add error:', error);
        if (errorContainer) {
          errorContainer.innerText = 'Could not add to cart';
        }
      });
  }

  container.querySelectorAll('.js-simple-add').forEach(button => {
    button.addEventListener('click', () => {
      const selector = button.closest('.product-quick-add__content') || button.previousElementSibling;
      const errorObj = errorChecking(selector);
      console.log('errorObj', errorObj);
      if (errorObj) {
        return;
      }
      quickAddToCart.call(button);
    });
  });

  container.querySelectorAll('.js-open-quick-selector').forEach(button => {
    button.addEventListener('click', function () {
      const selector = this.previousElementSibling;
      const errorObj = errorChecking(selector);
      if (errorObj) {
        return;
      }

      if (!selector) return;
      const visibleClass = 'is-visible';
      if (selector.classList.contains(visibleClass)) {
        selector.classList.remove(visibleClass);
        selector.dataset.currentStep = '1';
      } else {
        selector.classList.add(visibleClass);
      }
    });
  });

  container.querySelectorAll('.js-quick-variant-selection').forEach(button => {
    button.addEventListener('click', function () {
      const btn = this;
      // Find the parent .js-quick-add-selector
      const selector = btn.closest('.product-quick-add__content') || btn.previousElementSibling;
      const errorObj = errorChecking(selector);
      if (errorObj) {
        return;
      }
      if (!selector) return;

      const option = btn.getAttribute('data-option');
      const correspondingVariant = btn.getAttribute('data-corresponding-variant');
      const linkedProduct = btn.getAttribute('data-linked-product');
      const currentStep = parseInt(selector.dataset.currentStep, 10) || 1;
      const encodedVariants = selector.dataset.encodedVariants;
      if (!option || !correspondingVariant || !encodedVariants) return;

      // Parse variants
      const decodedVariantData = decodeURI(encodedVariants);
      let parsedVariantData;
      try {
        parsedVariantData = JSON.parse(decodedVariantData);
      } catch (e) {
        return;
      }

      // Find the current option wrapper and the next one
      const optionWrappers = selector.querySelectorAll('.js-quick-add-option-wrap');
      const currentWrapper = btn.closest('.js-quick-add-option-wrap');
      if (!currentWrapper) return;
      const nextWrapper = currentWrapper.nextElementSibling;
      selector.dataset.currentStep = currentStep + 1;

      // Filter variants for the next option
      let matchingVariants = parsedVariantData.filter(variant => {
        // For 2+ options, match all selected so far
        // For now, just match the current option
        return (
          variant.title.includes(option)
        );
      });

      // If there is a next option, render its buttons
      if (nextWrapper) {
        const grid = nextWrapper.querySelector('.js-quick-add-option-grid');
        if (!grid) return;
        // Get the next option name
        const nextOptionName = nextWrapper.getAttribute('data-step-option');
        // Get all possible values for the next option from matchingVariants
        const values = Array.from(new Set(matchingVariants.map(variant => {
          // Shopify variants: option1, option2, option3
          if (nextOptionName === 'size') return variant.option1;
          if (nextOptionName === 'color') return variant.option2;
          if (nextOptionName === 'material') return variant.option3;
          // fallback: try by index
          return variant['option' + (currentStep + 1)];
        }))).filter(Boolean);

        // Render buttons for the next option
        grid.innerHTML = values.map(value => {
          // Find the variant for this value
          const foundVariant = matchingVariants.find(variant => {
            return (
              variant['option' + (currentStep + 1)] === value
            );
          });
          if (!foundVariant) return '';
          // If this is the last option, render a button with data-variant-id
          const isLastStep = !nextWrapper.nextElementSibling;
          if (isLastStep) {
            return `
              <button
                type="button"
                class="product-quick-add__variant-option js-simple-add${nextOptionName === 'size' ? ' product-quick-add__variant-option--size' : ''}${foundVariant.inventory_quantity < 1 && foundVariant.inventory_policy === 'deny' && foundVariant.inventory_management === 'shopify' ? ' disabled' : ''}"
                data-variant-id="${foundVariant.id}"
              >
                ${value}
              </button>
            `;
          } else {
            // Otherwise, render another .js-quick-variant-selection button
            return `
              <button
                type="button"
                class="product-quick-add__variant-option js-quick-variant-selection${nextOptionName === 'size' ? ' product-quick-add__variant-option--size' : ''}${foundVariant.inventory_quantity < 1 && foundVariant.inventory_policy === 'deny' && foundVariant.inventory_management === 'shopify' ? ' disabled' : ''}"
                data-option="${value}"
                data-corresponding-variant="${nextOptionName}"
              >
                ${value}
              </button>
            `;
          }
        }).join('');

        // Re-attach event listeners for the new buttons
        grid.querySelectorAll('.js-quick-variant-selection').forEach(newBtn => {
          newBtn.addEventListener('click', arguments.callee);
        });
        grid.querySelectorAll('.js-simple-add').forEach(newBtn => {
          newBtn.addEventListener('click', quickAddToCart);
        });
      }
    });
  });
}

bindQuickAddEventsRecommendations();
document.addEventListener('facets:updated', () => bindQuickAddEventsRecommendations());
document.addEventListener('mini-cart:toggled', () => {
  console.log('mini-cart:toggled');
  setTimeout(() => {
    bindQuickAddEventsRecommendations(document.querySelector('.mini-cart'));
  }, 1000);
});


class PDProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.loadRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px 400px 0px" },
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    const url = `${this.dataset.url}4&product_id=${productId}&section_id=${this.dataset.sectionId}`;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector(".pd-recommendation-products__inner");

        if (recommendations?.innerHTML.trim().length) {
          this.querySelector(".pd-recommendation-products__inner").innerHTML = recommendations.innerHTML;
        }

        setTimeout(() => {
          const img = this.querySelector(".product-recommendation__image img");
          this.style.setProperty("--img-height", `${img.getBoundingClientRect().height}px`);
          bindQuickAddEventsRecommendations(this); // only within this block
        }, 100);

        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
        }

        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("pd-product-recommendations", PDProductRecommendations);

(() => {
  const clearAllButtons = document.querySelectorAll('[clear-all-button]') || [];

  clearAllButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const form = button.closest('facet-filters-form');

      if (form) {
        form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
          input.checked = false;
        })
      }
    });
  });
})();
